// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b9348691","239":"9dd2d3e5","420":"65797401","455":"ed62d60e","653":"c00f8a99","660":"c6bdbc0a","694":"d89e2aaf","762":"c954cc1a","778":"262a2ef5","858":"56e3e203","918":"57fbce91"}[chunkId] + ".chunk.js";
};